import * as bootstrap from "bootstrap";

export function showTmPlusFiltersModal(callback?: () => void) {
  const modalElement = document.querySelector("#tmplus-filters-modal");
  if (modalElement) {
    const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
    if (callback && typeof callback === "function") {
      modalElement.addEventListener("hidden.bs.modal", callback, {
        once: true,
      });
    }
    modalInstance.show();
  }
}
